module.exports = __webpack_public_path__ + "static/media/img_dianshang_2@2x.374fadfa.png";